import { DropdownSearchItem } from '@/modules/common/components/molecules/selectors/dropdown';
import { Manager } from '@/modules/projects/types/project';

import { ShortTeamMemberResponse } from '../types/dto/team-member-short.dto';

/**
 * Maps ShortTeamMemberResponse DTO to DropdownSearchItem for use in selectors
 * @param dto - Team member response from API
 * @returns Dropdown search item with team member data
 */
export const mapShortTeamMemberToDropdownItem = (
  dto: ShortTeamMemberResponse
): DropdownSearchItem => {
  return {
    id: String(dto.id),
    name: dto.name,
    avatarLink: dto.profileImageUrl ?? undefined,
    secondaryText: dto.email ?? undefined,
    status: dto.status,
  };
};

/**
 * Maps array of ShortTeamMemberResponse DTOs to DropdownSearchItem array
 * @param dtos - Array of team member responses from API
 * @returns Array of dropdown search items
 */
export const mapShortTeamMembersToDropdownItems = (
  dtos: ShortTeamMemberResponse[]
): DropdownSearchItem[] => {
  return dtos.map(mapShortTeamMemberToDropdownItem);
};

/**
 * Maps ShortTeamMemberResponse DTO to Manager domain model
 * @param dto - Team member response from API
 * @returns Manager domain model
 */
export const mapShortTeamMemberToManager = (dto: ShortTeamMemberResponse): Manager => {
  return {
    id: dto.id,
    name: dto.name,
    email: dto.email,
    profileImageUrl: dto.profileImageUrl,
    // Short team member didn't have isDeleted property
    // that required in Manager type
    isDeleted: false,
  };
};

/**
 * Maps array of ShortTeamMemberResponse DTOs to Manager array
 * @param dtos - Array of team member responses from API
 * @returns Array of Manager domain models
 */
export const mapShortTeamMembersToManagers = (dtos: ShortTeamMemberResponse[]): Manager[] => {
  return dtos.map(mapShortTeamMemberToManager);
};
